import useAlert from './useAlert'
import useCreateAffiliation from './useCreateAffiliation'
import useFormFields from './useFormFields'
import useSubmitBtns from './useSubmitBtns'

export default { useSubmitBtns, useAlert, useCreateAffiliation, useFormFields }